import { Badge, Dropdown, Flex, Tooltip, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../../../Icon"
import { alertsTooltipStatusText, remainingTime } from "../../../../Utils/utils"
import {
  alertStatusColorMap,
  alertStatusTextMap,
  attentionResolveOptions
} from "../../utils/alertStatusMapping"

import "./AlertStatusTag.less"

const { Text } = Typography

const AlertStatusTag = ({
  alert,
  disabledStatus,
  options = attentionResolveOptions,
  handleChangeStatus,
  changeStatusDisabled,
  height = "32px",
  isDemo
}) => {
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const _ = alert?.alert_status

  const tooltip =
    (alert?.["user_error_message"] || alert?.["error_message"]) && !disabledStatus ? (
      <Flex vertical={true} gap={8}>
        <span>{alert?.["user_error_message"]}</span>
        {alert?.["error_message"] ? <span>{alert?.["error_message"]}</span> : null}
      </Flex>
    ) : null

  let time = remainingTime(alert?.["alert_timestamp"], alert?.["alert_service"])
  if (typeof time === "string") {
    time = time.replace("-", "")
  }
  if (isDemo) time = null

  const isDropdownEnabled =
    _?.toLowerCase() === "attention" && !disabledStatus && !changeStatusDisabled

  return (
    <Flex gap={8} align="center" className="alert-status-tag-container">
      <Dropdown
        disabled={!isDropdownEnabled}
        className="alert-status-dropdown-trigger"
        trigger={["click"]}
        menu={{
          items: options.map((el) => {
            let statusLowerCase = el?.toLowerCase()
            let tooltipStatus = alertsTooltipStatusText[statusLowerCase]
              ? t(alertsTooltipStatusText[statusLowerCase])
              : null
            return {
              key: el,
              label: (
                <Tooltip
                  title={isMobile ? null : tooltipStatus}
                  placement={"right"}
                  destroyTooltipOnHide={true}
                >
                  <Flex gap={8} align="center">
                    <Badge color={alertStatusColorMap[el] || alertStatusColorMap["default"]} />
                    <Text strong>{alertStatusTextMap[el] || el}</Text>
                  </Flex>
                </Tooltip>
              )
            }
          }),
          onClick: ({ key, domEvent }) => {
            domEvent.stopPropagation()
            if (key !== _)
              handleChangeStatus({
                alert_id: alert.alert_id,
                newStatus: key
              })
          }
        }}
      >
        <Flex
          style={{ height }}
          gap={8}
          justify="center"
          align="center"
          className="alert-status-tag"
        >
          <Badge color={alertStatusColorMap[_] || alertStatusColorMap["default"]} />
          <Text strong>{alertStatusTextMap[_] || _}</Text>
          {Boolean(time) && _ === "Attention" && (
            <>
              <div className="time-divider" />
              <Text strong>{time}</Text>
            </>
          )}
          {isDropdownEnabled && <Icon type="chevron_down_small" style={{ marginLeft: -4 }} />}
        </Flex>
      </Dropdown>
      {Boolean(tooltip) && (
        <Tooltip title={tooltip} destroyTooltipOnHide={true}>
          <div style={{ height, width: height }} className="tooltip-trigger">
            <Icon type="triangle_exclamation2" />
          </div>
        </Tooltip>
      )}
    </Flex>
  )
}

export default AlertStatusTag
